export default __webpack_public_path__ + "static/media/hot-galvanizing-icon.784f9fbd.svg";